import { useParams } from 'react-router';

export const useDsRouteParams = () => {
  const params = useParams<{
    dsId: string | undefined;
    estateId: string | undefined;
    version: string | undefined;
  }>();
  return params;
};
